'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _lodashCompat = require('lodash-compat');

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _panel = require('../panel');

var _trigger = require('../../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _data = require('../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

//FIXME
var basicPrefixCls = 'time-picker';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};
var fix2Digits = function fix2Digits(s) {
  return ('0' + s).slice(-2);
};

/**
 * 时间选择器
 * props.value
 * props.placeholder = ''
 * //显示的时间格式，基于strftime，'%H:%M'|'%H:%M:%S'
 * props.format = '%H:%M'
 * props.required = false //是否必须
 * props.disabled = false //是否不可用
 * props.disabledHours = () => { return [] } //禁用的 时 数组
 * props.disabledMinutes = (hour) => { return [] } //禁用的 分钟 数组
 * props.disabledSeconds = (hour, minute) => { return [] } //禁用的 秒 数组
 * props.hideDisabledOptions = false //是否隐藏禁止的选项
 * props.onChange
 * props.prefixCls = 'mt' //类前缀
 * props.getPopupContainer = () => document.body //弹出框的父级
 * props.validation = '' //必填校验时的提示
 * props.validator = (value) => { return '123'|others } //其他校验，如果返回有文本值的字符串，则校验不通过，该字符串为提示文本
 * props.mode = 'default' // 'default'|'view' 默认模式|查看模式
 * props.emptyLabel = '' //查看模式下值空时的显示
 *
 */
var TimePicker = (_temp = _class = function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TimePicker).call(this, props));

    _this.state = {
      value: _this._formatTime(props.value || undefined),
      showList: false,
      valid: true
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!(0, _data.isEmptyString)(this.props.defaultValue) && (0, _data.isEmptyString)(this.state.value)) {
        var value = this._formatTime(this.props.defaultValue || undefined);
        this.setState({ value: value });
      }
      this.hideList = function (e) {
        if (!_this2.state.showList) {
          return;
        }
        var $container = _this2.refs.container;
        var $trigger = _this2.refs.trigger && _this2.refs.trigger.getPopupDOMNode();
        if ($container && !$container.contains(e.target) && (!$trigger || !$trigger.contains(e.target))) {
          _this2._toggleList(false);
          //收起下拉时校验
          _this2._isValid();
        }
      };
      window.addEventListener('click', this.hideList);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value')) {
        value = nextProps.value || undefined;
      }
      this.setState({ value: this._formatTime(value) });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.hideList);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var placeholder = _props.placeholder;
      var required = _props.required;
      var disabled = _props.disabled;
      var className = _props.className;
      var format = _props.format;
      var disabledHours = _props.disabledHours;
      var disabledMinutes = _props.disabledMinutes;
      var disabledSeconds = _props.disabledSeconds;
      var hideDisabledOptions = _props.hideDisabledOptions;
      var mode = _props.mode;
      var emptyLabel = _props.emptyLabel;
      var getPopupContainer = _props.getPopupContainer;
      var clearIcon = _props.clearIcon;
      var size = _props.size;
      var _state = this.state;
      var value = _state.value;
      var showList = _state.showList;
      var valid = _state.valid;
      var explain = _state.explain;


      if (mode == 'view') {
        return _react2.default.createElement(
          'div',
          { className: _util2.default.classNames(className, getCls(prefixCls, basicPrefixCls, ''), basicPrefixCls + '-view') },
          !value ? emptyLabel : value
        );
      } else {
        var _M$classNames;

        //className
        var containerCls = getCls(prefixCls, basicPrefixCls, '');
        var showFieldCls = getCls(prefixCls, basicPrefixCls, '-show-field');
        var placeholderCls = getCls(prefixCls, basicPrefixCls, '-placeholder');
        var showValueCls = getCls(prefixCls, basicPrefixCls, '-show-value');
        var timeMarkCls = getCls(prefixCls, basicPrefixCls, '-time-mark');
        var clearBtnCls = getCls(prefixCls, basicPrefixCls, '-clear-btn');
        var explainCls = getCls(prefixCls, basicPrefixCls, '-explain');
        var selectionCls = getCls(prefixCls, basicPrefixCls, '-selection');

        var timePanelProps = {
          value: value, format: format, prefixCls: prefixCls, disabledHours: disabledHours,
          disabledMinutes: disabledMinutes, disabledSeconds: disabledSeconds, hideDisabledOptions: hideDisabledOptions,
          onSelect: this._selectTime.bind(this)
        };

        return _react2.default.createElement(
          'div',
          { ref: 'container', className: _util2.default.classNames(className, containerCls, (_M$classNames = {}, _defineProperty(_M$classNames, basicPrefixCls + '-disabled', disabled), _defineProperty(_M$classNames, basicPrefixCls + '-required', required), _defineProperty(_M$classNames, basicPrefixCls + '-focused', showList), _defineProperty(_M$classNames, basicPrefixCls + '-sm', size === "small"), _defineProperty(_M$classNames, basicPrefixCls + '-invalid', !valid), _defineProperty(_M$classNames, 'has-error', !valid), _M$classNames)) },
          _react2.default.createElement(
            'div',
            { className: showFieldCls,
              onClick: !disabled && this._toggleList.bind(this, true) },
            !value && placeholder && _react2.default.createElement(
              'div',
              { className: placeholderCls },
              placeholder
            ),
            value && _react2.default.createElement(
              'div',
              { className: showValueCls },
              value
            ),
            _react2.default.createElement('span', { className: _util2.default.classNames(timeMarkCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-clock-o') }),
            !disabled && value && clearIcon && _react2.default.createElement('span', { className: _util2.default.classNames(clearBtnCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross-circle'),
              onClick: this._deleteHandler.bind(this) })
          ),
          _react2.default.createElement(
            _trigger2.default,
            { ref: 'trigger',
              prefixCls: prefixCls,
              className: _util2.default.classNames(basicPrefixCls + '__trigger', {
                'second-included': format.indexOf('%S') !== -1
              }),
              visible: showList,
              align: {
                points: ['tl', 'bl'],
                offset: [0, 2],
                overflow: {
                  adjustX: 1,
                  adjustY: 1
                }
              },
              equalTargetWidth: true,
              getPopupContainer: getPopupContainer,
              target: this._getRootTarget.bind(this) },
            _react2.default.createElement(
              'div',
              { className: selectionCls },
              _react2.default.createElement(_panel.TimePanel, timePanelProps)
            )
          ),
          !!explain && _react2.default.createElement(
            'div',
            { className: 'has-explain ' + explainCls },
            explain
          )
        );
      }
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      var onFocus = this.props.onFocus;

      onFocus && onFocus();
    }
  }, {
    key: '_onBlur',
    value: function _onBlur() {
      var onBlur = this.props.onBlur;

      onBlur && onBlur();
    }

    // 供Trigger使用, 获得当前DOM元素来定位弹框

  }, {
    key: '_getRootTarget',
    value: function _getRootTarget() {
      return (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: '_selectTime',
    value: function _selectTime(value) {
      this.setState({ value: value }, this._changeHandler);
    }
  }, {
    key: '_toggleList',
    value: function _toggleList(on) {
      var showList = this.state.showList;

      if (showList !== on) {
        this.setState({
          showList: on
        });
      }
      if (on) {
        this.clear();
        this._onFocus();
      } else {
        this._onBlur();
      }
    }
  }, {
    key: '_deleteHandler',
    value: function _deleteHandler(e) {
      this.setState({
        value: undefined,
        showList: false
      }, this._isValid.bind(this, this._changeHandler));
      //阻止冒泡，防止触发点击事件
      e.stopPropagation();
    }
  }, {
    key: '_formatTime',
    value: function _formatTime(value) {
      if (!value || value.length == 0) {
        return value;
      }
      return value.split(':').map(fix2Digits).join(':');
    }
  }, {
    key: '_changeHandler',
    value: function _changeHandler() {
      var onChange = this.props.onChange;

      onChange(this.state.value);
    }
  }, {
    key: '_isValid',
    value: function _isValid(callback) {
      var _props2 = this.props;
      var required = _props2.required;
      var validation = _props2.validation;
      var validator = _props2.validator;
      var value = this.state.value;


      var valid = true,
          explain = '';
      if (required && !value) {
        valid = false;
        explain = validation;
      } else if ((0, _lodashCompat.isFunction)(validator)) {
        var _result = validator(value);
        if (_result === false || (0, _lodashCompat.isString)(_result) && _result.length > 0) {
          valid = false;
          explain = _result || '';
        }
      }
      this.setState({ valid: valid, explain: explain }, callback);

      return valid;
    }

    /**
     * 调用本组件的校验
     * @returns {*}
     */

  }, {
    key: 'validate',
    value: function validate() {
      return this._isValid();
    }

    /**
     * 清空异常状态  校验提示等
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.setState({ valid: true, explain: '' });
    }

    /**
     * 重置控件，清空数据并清空校验状态
     */

  }, {
    key: 'reset',
    value: function reset() {
      if (this.props.mode !== "view") {
        var resetValue = this._formatTime(this.props.defaultValue || undefined);
        this.setState({
          value: resetValue,
          valid: true,
          explain: ""
        }, this._changeHandler);
      }
    }
  }]);

  return TimePicker;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  format: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  disabledHours: _propTypes2.default.func,
  disabledMinutes: _propTypes2.default.func,
  disabledSeconds: _propTypes2.default.func,
  hideDisabledOptions: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  prefixCls: _propTypes2.default.string,
  getPopupContainer: _propTypes2.default.func,
  validation: _propTypes2.default.string,
  validator: _propTypes2.default.func,
  mode: _propTypes2.default.oneOf(['default', 'view']),
  emptyLabel: _propTypes2.default.string,
  clearIcon: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['default', 'small']),
  // 以下两种属性仅提供给Records.Complex使用，不对外开放，未来可能会去掉
  onFocus: _propTypes2.default.func, //单击聚焦时，默认为单击输入框出现时间下拉时
  onBlur: _propTypes2.default.func }, _class.defaultProps = {
  placeholder: '',
  format: '%H:%M',
  required: false,
  disabled: false,
  disabledHours: _lodashCompat.noop,
  disabledMinutes: _lodashCompat.noop,
  disabledSeconds: _lodashCompat.noop,
  hideDisabledOptions: false,
  onChange: _lodashCompat.noop,
  prefixCls: 'mt',
  getPopupContainer: null,
  mode: 'default',
  emptyLabel: '',
  clearIcon: true,
  size: 'default'
}, _temp);
exports.default = TimePicker;